import { FC } from 'react'
import { IIconProps } from './interfaces'

interface IAnimatedMenuIconProps extends IIconProps {
    state: boolean
}

export const AnimatedMenuIcon: FC<IAnimatedMenuIconProps> = ({
    color = 'currentColor',
    size = 32,
    state,
}) => {
    const sharedTransition = 'opacity 0.24s ease, transform 0.28s ease'

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
            style={{
                display: 'block',
                color,
                overflow: 'visible',
            }}
        >
            <path
                fill="currentColor"
                d="M3 18v-2h18v2zm0-5v-2h18v2zm0-5V6h18v2z"
                style={{
                    opacity: state ? 0 : 1,
                    transform: state ? 'scaleX(0.55) rotate(90deg)' : 'scaleX(1) rotate(0deg)',
                    transformBox: 'fill-box',
                    transformOrigin: 'center',
                    transition: sharedTransition,
                }}
            />
            <path
                fill="currentColor"
                d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z"
                style={{
                    opacity: state ? 1 : 0,
                    transform: state ? 'scale(1) rotate(0deg)' : 'scale(0.72) rotate(-90deg)',
                    transformBox: 'fill-box',
                    transformOrigin: 'center',
                    transition: sharedTransition,
                }}
            />
        </svg>
    )
}